export default __webpack_public_path__ + "static/media/gman2.f52db750.png";